import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import HeroSlideshow from "./sections/HeroSlideshow";
import PremiumDfwTreeCare from "./sections/PremiumDfwTreeCare";
import TheArborProDifference from "./sections/TheArborProDifference";
import OurCoreServices from "./sections/OurCoreServices";
import EmergencyStormResponse from "./sections/EmergencyStormResponse";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import OurServiceFootprint from "./sections/OurServiceFootprint";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <HeroSlideshow />
      <PremiumDfwTreeCare />
      <TheArborProDifference />
      <OurCoreServices />
      <EmergencyStormResponse />
      <ClientSuccessStories />
      <OurServiceFootprint />
      <SiteFooter />
    </div>;
}